var parseData = require('./parse-data');

function toUrl(email) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return parseData(email, query).url;
}

module.exports = toUrl;